import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const containerStyles = css `
  ${styleUtils.borderBox}
  ${theme.typeStyles.bodySmallStyles}
  height: 100%;
  max-height: 100%;
  overflow-wrap: break-word;
  overflow-y: auto;
  padding-bottom: ${theme.spacing.x4};
  padding-left: ${theme.spacing.x4};
  padding-right: ${theme.spacing.x4};
  padding-top: ${theme.spacing.x4};
`;
const DrawerBody = ({ children, }) => (_jsx("div", Object.assign({ css: containerStyles }, { children: children })));
const MemoizedDrawerBody = memo(DrawerBody);
export { MemoizedDrawerBody as DrawerBody };
// MC-1068 Temporary hack for Storybook.
export default DrawerBody;
